<template>
	<router-view v-slot="{ Component }">
		<component :is="Component" :stream="stream" :stream-alive="streamAlive" :media-pulse="mediaPulse" />
	</router-view>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
	name: 'StreamsManageAnalyticsInputHealthCharts',
	components: {
	},
	props: {
		stream: {
			type: Object,
			required: true,
			validator(v) {
				return Object.prototype.hasOwnProperty.call(v, '_id');
			}
		},
		streamAlive: {
			type: Boolean,
		},
		mediaPulse: {
			type: Object,
			default: null,
		}
	},
	data() {
		return {};
	},
	computed: {
	},
	mounted() {
	},
	methods: {
		
	}
};
</script>

<style scoped>
</style>
